"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 233px)'
};
const modalContainer = theme => ({
    padding: 24,
    width: 'fit-content',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = {
    padding: 10,
    paddingTop: 0,
    width: 432,
    height: 376,
};
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    marginBottom: 24,
    cursor: 'move'
};
const itemAdd = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 24,
    alignItems: 'center',
    gridTemplateColumns: '140px 225px',
};
const inputItem = {
    height: 27,
    borderRadius: 5
};
const buttonSave = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonTitle = {
    margin: 0,
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '500',
    lineHeight: '24px'
};
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
};
const dropdownStyle = theme => ({
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
exports.default = {
    itemAdd,
    inputItem,
    gridHeight,
    modalTitle,
    buttonSave,
    modalHeader,
    buttonTitle,
    buttonDelete,
    dropdownStyle,
    modalContainer,
    modalConfirmContainer,
};
